var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"flex-column caption",attrs:{"app":"","absolute":""}},[_c('p',{staticClass:"ma-4"},[_c('a',{attrs:{"href":"https://dls.staatsarchiv.bs.ch/de/%C3%BCber-uns/disclaimer/"}},[_vm._v("Disclaimer")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }